import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LayoutHeader from '../../layout/LayoutHeader';
import { sendOtpToEmailThunk } from '../../store/auth/authThunk';
import { setErrorAlert } from '../../store/alert/alertSlice';
import DizeeInput from '../../components/DizeeComponent/DizeeInput';

export default function TeamMemberNewEmail() {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const sendVerifyCode = () => {
        if (!email.trim()) {
            dispatch(setErrorAlert('Please enter an email address'));
            return;
        }

        if (!isValidEmail(email)) {
            dispatch(setErrorAlert('Please enter a valid email address'));
            return;
        }

        // Send OTP to new email
        dispatch(sendOtpToEmailThunk(email));
        localStorage.setItem('newTeamMemberEmail', email);
        navigate('/team-member/verify-new-email');
    };

    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className="px-4 my-[50px] flex w-full justify-between">
                    <p className="text-white">Change email address</p>
                    <div className='flex gap-[20px]'>
                        <p onClick={() => navigate('/team-member/advanced')} className='text-white cursor-pointer'>Go back</p>
                    </div>
                </div>

                <div className="w-full px-4">
                    <div className="flex flex-col justify-between">
                        <div className="py-6 flex flex-col gap-y-6">
                            <div className="text-white">
                                Enter your new email address
                            </div>
                            <div className="flex flex-col gap-y-[40px]">
                                <DizeeInput
                                    placeholder={"Email address"}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <div className="flex justify-start w-full">
                                    <button 
                                        className="text-white cursor-pointer text-[12px] h-[18px] leading-[18px]"
                                        onClick={sendVerifyCode}
                                    >
                                        Send verification code
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutHeader>
    );
} 